<template>
<v-layout row wrap>
    <v-flex xs12 sm12>
    <v-menu
        ref="menu"
        v-model="menu"
        :close-on-content-click="false"
        :nudge-right="40"
        :return-value.sync="date"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        max-width="290px"
        min-width="290px"
    >
        <template v-slot:activator="{ on }">
            <v-text-field
                v-model="date"
                label="Month"
                readonly
                v-on="on"
            ></v-text-field>
        </template>
        <v-date-picker
        v-model="date"
        type="month"
        no-title
        scrollable
        >
            <v-spacer></v-spacer>
            <v-btn flat color="primary" @click="menu = false">Cancel</v-btn>
            <v-btn flat color="primary" @click="save_date(date)">OK</v-btn>
        </v-date-picker>
    </v-menu>
    </v-flex>
</v-layout>
</template>

<script>
import moment from 'moment';

export default {
data () {
return {
    date: new Date().toISOString().substr(0, 7),
    menu: false,
    modal: false
}},
mounted()  {
    this.format_data(new Date().toISOString().substr(0, 7));
},

methods: {
    format_data(e) {
            const date = new Date(e);
            const start_date = new Date(date.getFullYear(), date.getMonth(), 0);
            const end_date = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    },
    emit_date(timeperiod) {
        this.$emit('newData', timeperiod)
    },
    save_date(new_date) {
        this.$refs.menu.save(new_date);
        this.emit_date(this.month_to_timestamp(new_date));
    },
    month_to_timestamp(date) {
        // YYYY-MM
        let split_date = date.split("-");

        let start_date = moment([split_date[0], split_date[1] - 1]).startOf('month').unix();
        let end_date = moment([split_date[0], split_date[1] - 1]).endOf('month').unix();

        return [start_date, end_date];
    }
}
}
</script>
<style scoped>

</style>